var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fieldType"},[_c(_vm.customField || _vm.field,_vm._b({tag:"component",on:{"event":function($event){return _vm.$emit('event', $event)}}},'component',[_vm.propsData, _vm.propsValue, {alt: _vm.alt}],false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }